import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const ApplyPckgProdImgBlock = styled.div`
    position: relative;
    width: ${props => props.width ||'100px'};
    height: ${props => props.width ||'100px'};
    margin-bottom: 5px;
    cursor: pointer;

    &:hover .ApplyPckgProdDelBtnBlockClass {
        display: ${props => props.noshowDel ? 'none' : 'block'};;
    }

    &:hover .ApplyPckgProdDimClass {
        opacity: ${props => props.showDim} ;
    }
   
`;

const ApplyPckgProdDimBlock = styled.div`
    position: absolute;
    top: 0;
    width: ${props => props.width ||'100px'};
    height: ${props => props.width ||'100px'};
    -webkit-transition: opacity 0.3s;
    -o-transition: opacity 0.3s;
    transition: opacity 0.3s;
    overflow: hidden;
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    opacity: 0;
`;

const ApplyPckgProdSpanBlock = styled.span`
    color: #fff;
    display: block;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 100%;
    padding: 0 5px;
`;


const ApplyPckgProdDelBtnBlock = styled.button`
    display: ${props => props.show ? 'block' : 'none'};
    position: absolute;
    top: -8px;
    right: -8px;
    width: 20px;
    height: 20px;
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;

const ApplyPckgProdImgBtnBlock = styled.img`
    border-radius: 4px;
    min-width: 100%;
    height: 100%;
    vertical-align: middle;
    object-fit: cover;
`;

const ApplyPckgProdWDimPBlock = styled.div`
    position: absolute;
    top: 0;
    width: ${props => props.width ||'100px'};
    height: ${props => props.width ||'100px'};
    overflow: hidden;
    //border-radius: 4px;
    background-color: rgba(255,255,255,0.7);
    pointer-events: none;
`;

const ApplyPckgProdImg = ({ img, id, onDelClick, alwaysShowDelBtn, cateName = "", noShowDelBtn = false, isShowWDim = false, isLinkNo = false , width="100px"}) => {


    const handleDelClick = () => {
        return onDelClick();
    }

    return (
        <ApplyPckgProdImgBlock showDim={cateName === "" ? 0 : 1} noshowDel = {noShowDelBtn} width={width}>
            {isLinkNo===true ?
            <Link>
            <ApplyPckgProdImgBtnBlock src={img} />

            <ApplyPckgProdDimBlock
                className="ApplyPckgProdDimClass" width={width}>
                <ApplyPckgProdSpanBlock>
                    {cateName}
                </ApplyPckgProdSpanBlock>
            </ApplyPckgProdDimBlock>
            {isShowWDim&&<ApplyPckgProdWDimPBlock width={width}/>}
        </Link>
        :
        <Link to={"/prod?prodid=" + id} target="_blank">
                <ApplyPckgProdImgBtnBlock src={img} />

                <ApplyPckgProdDimBlock
                    className="ApplyPckgProdDimClass" width={width}>
                    <ApplyPckgProdSpanBlock>
                        {cateName}
                    </ApplyPckgProdSpanBlock>
                </ApplyPckgProdDimBlock>
                {isShowWDim&&<ApplyPckgProdWDimPBlock width={width}/>}
            </Link>
        }
            

            <ApplyPckgProdDelBtnBlock
                img="/assets/images/icon/tag_delete-icon.png"
                className="ApplyPckgProdDelBtnBlockClass"
                onClick={handleDelClick}
                show={alwaysShowDelBtn} />

        </ApplyPckgProdImgBlock>
    );
};

export default ApplyPckgProdImg;
